export class UpdateArchivoRequest {
  public id: number = 0
  public descripcion: string|null= null;
  public content:string|null= null;
  public fechaAlta:Date = new Date ;
  public encriptado:boolean= false;
  public contentType: string|null = null;
  public nombre: string="";
}
